import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { routes } from './routes';
import { initModules } from './app/bootstrap';
import { createRequestFeedbackCaches } from './shared/request-feedback';

// Costura os módulos (DI) antes de qualquer render — equivalente ao
// bootstrap do AppModule no NestJS.
initModules();

const router = createBrowserRouter(routes);

const queryClient = new QueryClient({
  // Escrita que falha vira toast + console; leitura que falha vira console.
  // É uma garantia do cliente inteiro, e não de cada `useMutation`: um
  // `onError` esquecido deixava a ação sem resposta nenhuma. Ver
  // `shared/request-feedback.ts`.
  ...createRequestFeedbackCaches(),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {/* Mesma configuração do `aristo-dashboards`: o monorepo já escolheu
          `sonner`, e um segundo mecanismo de aviso só faria o admin avisar
          diferente do resto. `richColors` é o que dá verde/vermelho sem cada
          chamada ter de estilizar. Fica fora do router: não depende de rota. */}
      <Toaster position="top-right" richColors />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
